import { render, staticRenderFns } from "./titleCard.vue?vue&type=template&id=fd69c1ac&"
import script from "./titleCard.vue?vue&type=script&lang=js&"
export * from "./titleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports